export default {
  HAS_SELECTED_PROFILE: "hasSelectedProfile",
};
